import { queryKeys } from "../react-query/constants";
import { getLoginToken } from "../storage";
import { axiosInstance } from "../axios-Instance";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

async function getPost() {
  const data = await axiosInstance({
    url: "/post",
    method: "GET",
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

async function createPost(formData) {
  const data = await axiosInstance({
    url: "/post",
    method: "POST",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function updatePost(formData) {
  const data = await axiosInstance({
    url: `/post/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return data?.data?.data;
}

async function deletePost(formData) {
  const data = await axiosInstance({
    url: `/post/${formData}`,
    method: "DELETE",
    data: formData,
    headers: {
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });

  return data?.data?.data;
}

export function usePost() {
  const fallback = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.posts],
    queryFn: getPost,
  });
  return data;
}

export function useUpdatePost() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => updatePost(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.posts]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}

export function useAddPost() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => createPost(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.posts]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
export function useDeletePost() {
  const queryClient = useQueryClient();
  const { mutate, isError, isSuccess, error, reset } = useMutation({
    mutationFn: (formData) => deletePost(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.posts]);
    },
  });
  return { mutate, isError, isSuccess, error, reset };
}
